import { useEffect, useState, useCallback } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { CartProvider, useCart } from "./context/CartContext";
import { getCheckoutStatus } from "./lib/api";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Episodes from "./components/Episodes";
import About from "./components/About";
import Shop from "./components/Shop";
import CartDrawer from "./components/CartDrawer";
import Ecosystem from "./components/Ecosystem";
import ConnectedShows from "./components/ConnectedShows";
import Newsletter from "./components/Newsletter";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Admin from "./components/Admin";
import Merch from "./components/Merch";

function PaymentWatcher() {
  const [params, setParams] = useSearchParams();
  const { clearCart } = useCart();
  const [checked, setChecked] = useState(false);

  const poll = useCallback(
    async (sessionId, attempts = 0) => {
      const MAX = 6;
      if (attempts >= MAX) {
        toast.error("Payment status check timed out. Check your email for confirmation.");
        return;
      }
      try {
        const data = await getCheckoutStatus(sessionId);
        if (data.payment_status === "paid") {
          clearCart();
          toast.success("Payment successful! Thank you for your order.");
          return;
        }
        if (data.status === "expired") {
          toast.error("Payment session expired. Please try again.");
          return;
        }
        setTimeout(() => poll(sessionId, attempts + 1), 2000);
      } catch {
        setTimeout(() => poll(sessionId, attempts + 1), 2000);
      }
    },
    [clearCart]
  );

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (sessionId && !checked) {
      setChecked(true);
      toast.loading("Confirming your payment…", { id: "pay", duration: 2500 });
      poll(sessionId);
      params.delete("session_id");
      setParams(params, { replace: true });
      setTimeout(() => {
        document.getElementById("shop")?.scrollIntoView({ behavior: "smooth" });
      }, 400);
    }
  }, [params, checked, poll, setParams]);

  return null;
}

function Landing() {
  return (
    <div className="grain">
      <Navbar />
      <CartDrawer />
      <PaymentWatcher />
      <main>
        <Hero />
        <Episodes />
        <About />
        <Shop />
        <Ecosystem />
        <ConnectedShows />
        <Newsletter />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/shop" element={<Landing />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/merch" element={<Merch />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
